import React from 'react'

const Success = () => {
  return (
    <div>
      <center><h1>Ваша анкета принята</h1></center>
      <p style={{
        marginLeft: '15%',
        marginRight: '15%',
      }}>* Наши специалисты подберут для вас подходящие вакансии на основе ваших навыков и предпочтений. База trudos.ru содержит тысячи предложений от работодателей по всей России. Вы можете найти работу в различных сферах: IT, производство, сервис, торговля, управление и многие другие. Зарплаты от 30 000 до 300 000 рублей в зависимости от квалификации и региона. Мы также предлагаем помощь в составлении резюме и подготовке к собеседованию. Для поиска работы необходимо заполнить анкету на сайте. Сервис бесплатный для соискателей.</p>
    </div>
  )
}

export default Success